import React from 'react';
import { ArticleHeading4, ArticleHeading3, UIText2, useDeviceType } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import styles from './styles.css';

interface IInfoBlockProps {
  title: string;
  text: string;
}

export const InfoBlock: React.FC<IInfoBlockProps> = ({ title, text }) => {
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <>
      <div className={styles['title']}>
        <UIText2 color={'current_color'}>{title}</UIText2>
      </div>
      <ConditionalWrapper if={isDesktop} ThenComponent={ArticleHeading4} ElseComponent={ArticleHeading3}>
        {text}
      </ConditionalWrapper>
    </>
  );
};
